"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactVis = require("react-vis");

var _reactVirtualizedAutoSizer = _interopRequireDefault(require("react-virtualized-auto-sizer"));

var _excluded = ["children", "dataTestid"],
    _excluded2 = ["children", "margin", "className", "height", "dataTestid"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FakeAutoSizer = function FakeAutoSizer(_ref) {
  var children = _ref.children,
      dataTestid = _ref.dataTestid,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: 1000,
      height: 300
    },
    "data-testid": dataTestid
  }, children(_objectSpread({
    width: 1000,
    height: 300
  }, rest)));
};

FakeAutoSizer.propTypes = _reactVirtualizedAutoSizer["default"].propTypes;
var AutoSizer = process.env.NODE_ENV === 'test' ? FakeAutoSizer : _reactVirtualizedAutoSizer["default"];

var ResizableXYPlot = function ResizableXYPlot(_ref2) {
  var children = _ref2.children,
      margin = _ref2.margin,
      className = _ref2.className,
      height = _ref2.height,
      dataTestid = _ref2.dataTestid,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var disableHeight = false;

  if (height) {
    disableHeight = true;
  }

  return /*#__PURE__*/_react["default"].createElement(AutoSizer, {
    disableHeight: disableHeight,
    className: className,
    dataTestid: dataTestid
  }, function (_ref3) {
    var width = _ref3.width,
        autoHeight = _ref3.height;
    return /*#__PURE__*/_react["default"].createElement(_reactVis.XYPlot, _extends({
      width: width,
      margin: margin,
      height: height || autoHeight
    }, rest), children);
  });
};

ResizableXYPlot.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  disableHeight: _propTypes["default"].bool,
  height: _propTypes["default"].number,
  margin: _propTypes["default"].shape({
    left: _propTypes["default"].number,
    right: _propTypes["default"].number
  }),
  className: _propTypes["default"].string,
  dataTestid: _propTypes["default"].string
};
ResizableXYPlot.defaultProps = {
  disableHeight: true,
  height: undefined,
  margin: {
    left: 0,
    right: 0
  },
  className: undefined,
  dataTestid: undefined
};
var _default = ResizableXYPlot;
exports["default"] = _default;